// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Qe","innerTile":"Re","heading":"Se","instaTileBtn":"Te","disabled":"Ue","instaTileElement":"Ve","instagramPic":"We"};